import { MutationTree } from 'vuex';
import { SuiviFacturesEnRetardState } from '.';
import { SUIVI_FACTURES_EN_RETARD } from './mutation-types';
import { SortType } from '@/models/SortType';
import { SuiviFacture } from '@/models/SuiviFacture';

export const mutations: MutationTree<SuiviFacturesEnRetardState> = {

    [SUIVI_FACTURES_EN_RETARD.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },

    [SUIVI_FACTURES_EN_RETARD.SET_ITEMS_EN_RETARD](state, items: SuiviFacture[]) {
        state.facturesEnRetard = items;
    },
    [SUIVI_FACTURES_EN_RETARD.ADD_ITEMS](state, items: SuiviFacture[]) {
        state.facturesEnRetard = [...state.facturesEnRetard, ...items];
    },
    [SUIVI_FACTURES_EN_RETARD.SET_PAGE_EN_RETARD](state, page: number) {
        state.page = page;
    },
    [SUIVI_FACTURES_EN_RETARD.SET_NB_OF_PAGES_EN_RETARD](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_FACTURES_EN_RETARD.SET_COUNT_EN_RETARD](state, count: number) {
        state.count = count;
    },
    [SUIVI_FACTURES_EN_RETARD.SET_SORT_EN_RETARD](
        state,
        sort:
            | {
                  sortData: string;
                  sortType: SortType;
              }
            | undefined
    ) {
        state.sort = sort;
    },
    [SUIVI_FACTURES_EN_RETARD.SET_IS_LOADING_EN_RETARD](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_FACTURES_EN_RETARD.SET_ERROR_EN_RETARD](state, error: Error | undefined) {
        state.error = error;
    },

    [SUIVI_FACTURES_EN_RETARD.RESET_ITEMS](state) {
        state.facturesEnRetard = [];
    },

};
